import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import JBImage from 'components/essentials/JBImage';
import CollectionsGridMobilePlaceholders from './CollectionsGridMobilePlaceholders';
const CollectionsGridMobile = t0 => {
  const $ = _c(6);
  const {
    collections,
    loading,
    setSelectedCollection
  } = t0;
  let t1;
  if ($[0] !== collections || $[1] !== loading || $[2] !== setSelectedCollection) {
    t1 = loading ? <CollectionsGridMobilePlaceholders /> : collections.map(collection => collection.images[0] && <button className="text-left" key={collection.id} onClick={() => setSelectedCollection(collection)} type="button"><JBImage src={collection.images[0].url} alt="" sizes="100vw" ar="1:1" /><div className="mx-0 my-8 px-4 py-0"><h4 className="text-sm font-bold mb-[.325rem] text-gray">{collection.name}</h4><div className="text-xs text-gray">{collection.category_description || collection.category_meta_description}</div></div></button>);
    $[0] = collections;
    $[1] = loading;
    $[2] = setSelectedCollection;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className="md:hidden">{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
CollectionsGridMobile.propTypes = {
  collections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    category_description: PropTypes.string,
    category_meta_description: PropTypes.string,
    images: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string.isRequired
    })).isRequired
  })).isRequired,
  loading: PropTypes.bool,
  setSelectedCollection: PropTypes.func
};
export default CollectionsGridMobile;